











import { Component, Vue } from 'vue-property-decorator';
import ProfileForm from '@/components/forms/ProfileForm.vue';

@Component({
    components: {
        ProfileForm
    }
})
export default class Home extends Vue {
    private created() {
        this.$store.dispatch('initializeUserProfile', true);
    }
}
